import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Form, Input, Popover, InputNumber, Icon } from "antd";

const reactStringReplace = require("react-string-replace");

const convertBasedOnLevel = require("../utilities/calc-stats");

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  componentDidMount() {
    if (this.props.editable) {
      document.addEventListener("click", this.handleClickOutside, true);
    }
  }

  componentWillUnmount() {
    if (this.props.editable) {
      document.removeEventListener("click", this.handleClickOutside, true);
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  handleClickOutside = (e) => {
    const { editing } = this.state;
    if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
      this.save();
    }
  };

  componentDidUpdate() {
    // const {
    //   editable,
    //   dataIndex,
    //   title,
    //   record,
    //   index,
    //   handleSave,
    //   ...restProps
    // } = this.props;
    // console.log(JSON.stringify(record));
    // console.log("componentdidupdate");
  }

  save = () => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  checkLevel = (rule, value, callback) => {
    if (value > 0) {
      callback();
      return;
    }
    callback("Level must be >0!");
  };

  render() {
    const { editing } = this.state;
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      ...restProps
    } = this.props;
    return (
      <td ref={(node) => (this.cell = node)} {...restProps}>
        {editable ? (
          <EditableContext.Consumer>
            {(form) => {
              this.form = form;
              return editing ? (
                <FormItem style={{ margin: 0 }}>
                  {form.getFieldDecorator(dataIndex, {
                    rules: [
                      {
                        validator: this.checkLevel,
                        type: "number",
                        required: true,
                      },
                    ],
                    initialValue: record[dataIndex],
                  })(
                    <Input
                      ref={(node) => (this.input = node)}
                      onPressEnter={this.save}
                    />
                  )}
                </FormItem>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  onClick={this.toggleEdit}
                >
                  {restProps.children}
                </div>
              );
            }}
          </EditableContext.Consumer>
        ) : (
          restProps.children
        )}
      </td>
    );
  }
}

class CompareTable extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      // {
      //   title: "No.",
      //   width: 70,
      //   align: "center",
      //   dataIndex: "number",
      //   key: "number",
      //   sorter: (a, b) => {
      //     var nameA = a.key.toUpperCase();
      //     var nameB = b.key.toUpperCase();
      //     if (nameA < nameB) {
      //       return -1;
      //     }
      //     if (nameA > nameB) {
      //       return 1;
      //     }
      //     return 0;
      //   }
      // },

      {
        title: (
          <div>
            <Popover
              trigger="click"
              placement="topLeft"
              content={
                <div onClick={(e) => e.stopPropagation()}>
                  냥코 레벨: &nbsp;
                  <InputNumber
                    min={1}
                    max={999}
                    defaultValue={this.props.presetCatLevels}
                    size="small"
                    onChange={this.onInputNumberChange.bind(this)}
                  />
                </div>
              }
            >
              <Button style={{ padding: "0px 12px" }}>
                <Icon type="setting" />
              </Button>
            </Popover>
          </div>
        ),
        width: 57,
        dataIndex: "img",
        key: "img",
        fixed: "left",
        render: (text, record) => (
          // <a
          //   href={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          //   // target="_blank"
          // >
          <Link
            to={"/kr/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          >
            <img
              src={
                "https://onestoppress.com/images/" +
                record.number +
                "_square.png"
              }
              alt={record.name}
            />
          </Link>
          // </a>
        ),
      },
      {
        title: "이름",
        width: 120,
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          // <a
          //   href={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          //   // target="_blank"
          // >
          <Link
            to={"/kr/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          >
            {record.name}
          </Link>
          // </a>
        ),
      },
      {
        title: "단",
        width: 100,
        dataIndex: "form",
        key: "form",
        render: (text, record) => (
          <Button
            // type="primary"
            style={{
              display: "block",
              width: "66px",
              paddingLeft: "8px",
              paddingRight: "8px",
            }}
            onClick={this.onChangeFormClick.bind(
              this,
              record.number,
              record.level2,
              record.key
            )}
          >
            {text}
          </Button>
        ),
        filters: [
          {
            text: "기본",
            value: "기본",
          },
          {
            text: "2진",
            value: "2진",
          },
          {
            text: "3진",
            value: "3진",
          },
          {
            text: "4진",
            value: "4진",
          },
        ],
        onFilter: (value, record) => record.form.indexOf(value) === 0,
      },
      {
        title: "레어도",
        dataIndex: "rarity",
        key: "rarity",
        width: 75,
        filters: [
          {
            text: "노멀",
            value: "노멀",
          },
          {
            text: "EX",
            value: "EX",
          },
          {
            text: "레어",
            value: "레어",
          },
          {
            text: "슈레",
            value: "슈레",
          },
          {
            text: "울슈레",
            value: "울슈레",
          },
          {
            text: "레레",
            value: "레레",
          },
        ],
        onFilter: (value, record) => record.rarity.indexOf(value) === 0,
      },
      // {
      //   title: "Level",
      //   dataIndex: "level",
      //   key: "level",
      //   width: 100,
      //   align: "center"
      // },
      {
        title: "레벨",
        dataIndex: "level2",
        key: "level2",
        width: 90,
        align: "center",
        editable: true,
        render(text) {
          return (
            <div style={{ textAlign: "center" }}>
              <span
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "4px",
                  padding: "4px 11px",
                  display: "block",
                }}
              >
                {text}
              </span>
            </div>
          );
        },
      },
      {
        title: "체력",
        dataIndex: "health2",
        key: "health2",
        width: 75,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.health
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.health
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.health;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "공격력",
        dataIndex: "damage2",
        key: "damage2",
        width: 75,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.damage
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.damage
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.damage;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
              {/* {typeof isCrazed} */}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "사거리",
        dataIndex: "range",
        key: "range",
        width: 75,
        align: "center",
        sorter: (a, b) => a.range - b.range,
      },
      {
        title: "히트백",
        dataIndex: "kb",
        key: "kb",
        width: 75,
        align: "center",
        sorter: (a, b) => a.kb - b.kb,
      },
      {
        title: "스피드",
        dataIndex: "speed",
        key: "speed",
        width: 75,
        align: "center",
        sorter: (a, b) => a.speed - b.speed,
      },
      {
        title: "DPS",
        dataIndex: "dps2",
        key: "dps2",
        width: 70,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.dps
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.dps
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.dps;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
              {/* {typeof isCrazed} */}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "공격타입",
        dataIndex: "target",
        key: "target",
        width: 90,
        align: "center",
        filters: [
          {
            text: "단일",
            value: "단일",
          },
          {
            text: "범위",
            value: "범위",
          },
        ],
        onFilter: (value, record) => record.target.indexOf(value) === 0,
      },
      {
        title: "공격 간격",
        dataIndex: "tba",
        key: "tba",
        width: 70,
        align: "center",
        sorter: (a, b) => a.tba - b.tba,
      },
      {
        title: "선딜",
        dataIndex: "anim",
        key: "anim",
        width: 70,
        align: "center",
        sorter: (a, b) => a.anim - b.anim,
      },
      {
        title: "쿨타임",
        dataIndex: "spawn",
        key: "spawn",
        width: 75,
        align: "center",
        sorter: (a, b) => a.spawn - b.spawn,
      },
      {
        title: "코스트",
        dataIndex: "cost",
        key: "cost",
        width: 75,
        align: "center",
        sorter: (a, b) => a.cost - b.cost,
      },
      {
        title: "타겟",
        dataIndex: "enemy",
        key: "enemy",
        width: 130,
        align: "center",
        filters: [
          {
            text: "빨간적",
            value: "빨간적",
          },
          {
            text: "떠있는 적",
            value: "떠있는 적",
          },
          {
            text: "검은적",
            value: "검은적",
          },
          {
            text: "메탈",
            value: "메탈",
          },
          {
            text: "천사",
            value: "천사",
          },
          {
            text: "에이리언",
            value: "에이리언",
          },
          {
            text: "좀비",
            value: "좀비",
          },
          {
            text: "고대종",
            value: "고대종",
          },
          {
            text: "악마",
            value: "악마",
          },
          {
            text: "무속성",
            value: "무속성",
          },
          {
            text: "기지",
            value: "기지",
          },
        ],
        onFilter: function (value, record) {
          return record.ability.includes(
            record.ability.match(new RegExp(value)) !== null
              ? record.ability.match(new RegExp(value))[0]
              : "-1"
          );
        },
        render(text, record) {
          const enemylist = [
            "빨간적",
            "떠있는 적",
            "검은적",
            "메탈",
            "천사",
            "에이리언",
            "좀비",
            "고대종",
            "악마",
            "무속성",
          ];
          var enemy = "";
          const ability = record.ability;

          for (var i = 0; i < enemylist.length; i++) {
            if (ability.includes(enemylist[i].toLowerCase())) {
              if (enemy.length > 0) {
                enemy += ", " + enemylist[i];
              } else {
                enemy = enemylist[i];
              }
            }
          }

          return <div>{enemy}</div>;
        },
      },
      {
        title: "능력",
        dataIndex: "ability",
        key: "ability",
        filters: [
          { text: "격파시 머니 UP", value: "격파시 머니 UP" },
          { text: "공격 무효", value: "공격 무효" },
          { text: "공격력 업", value: "공격력 업" },
          { text: "타겟 한정", value: "타겟 한정" },
          { text: "공격력 다운", value: "(?!.*영향을 받지 않음u2:.*공다)^.*공격력 다운" },
          { text: "파동 무효", value: "영향을 받지(.*파동)" },
          { text: "극데미지", value: "극데미지" },
          {
            text: "날려버린다",
            value: "(?!.*영향을 받지 않음u2:.*밀치기)^.*날려버린다",
          },
          {
            text: "느리게 한다",
            value: "(?!.*영향을 받지 않음u2:.*느리게)^.*느리게 한다",
          },
          { text: "느리게 내성", value: "영향을 받지(.*느리게)" },
          { text: "독 데미지 무효", value: "영향을 받지(.*독)" },
          { text: "다중 공격", value: "다중 공격" },
          { text: "메탈", value: "제외하고 1만 받음" },
          { text: "멧집이 좋다", value: "멧집이 좋다" },
          { text: "밀치기 내성", value: "영향을 받지(.*밀치기)" },
          { text: "베리어 브레이커", value: "베리어 브레이커" },
          { text: "사도 킬러", value: "사도 킬러" },
          { text: "살아남는다", value: "살아남는다" },
          { text: "성 파괴가 특기", value: "성 파괴가 특기" },
          { text: "소파동", value: "소파동" },
          { text: "쉴드 브레이커", value: "쉴드 브레이커" },
          { text: "공다 무효", value: "영향을 받지(.*공다[^내성])" },
          { text: "엄청 강하다", value: "엄청 강하다" },
          {
            text: "열파 공격",
            value: "u1일반 능력u2:.[^\n]*?\\b열파 공격\\b",
          },
          { text: "열파 공격 무효", value: "영향을 받지(.*열파)" },
          { text: "워프 무효", value: "영향을 받지(.*워프)" },
          { text: "원거리 공격", value: "원거리 공격" },
          { text: "저주", value: "(?!.*영향을 받지 않음u2:.*저주)^.*저주" },
          { text: "저주 무효", value: "영향을 받지(.*저주)" },
          { text: "전방위 공격", value: "전방위 공격" },
          { text: "멈춘다", value: "(?!.*영향을 받지 않음u2:.*멈춘다)^.*멈춘다" },
          { text: "멈춘다 내성", value: "영향을 받지(.*멈춘다)" },
          { text: "좀비 킬러", value: "좀비 킬러" },
          { text: "초맷집이 좋다", value: "초맷집이 좋다" },
          { text: "초데미지", value: "초데미지" },
          { text: "초생명체 특효", value: "초생명체 특효" },
          { text: "초수 특효", value: "초수 특효" },
          { text: "크리티컬", value: "크리티컬.[^히트를]" },
          { text: "파동 공격", value: "파동 공격" },
          { text: "파동 스톱퍼", value: "파동 스톱퍼" },
          { text: "혼신의 일격", value: "혼신의 일격" },
        ],
        onFilter: function (value, record) {
          return record.ability.match(new RegExp(value)) !== null;
        },
        render(text) {
          const formattedb = reactStringReplace(
            text,
            /b1(.+?)b2/g,
            (match, i) => <b key={"b" + i}>{match}</b>
          );
          const formattedu = reactStringReplace(
            formattedb,
            /u1(.+?)u2/g,
            (match, i) => <u key={"u" + i}>{match}</u>
          );

          return {
            props: {
              style: { whiteSpace: "pre-wrap" },
            },
            children: <div>{formattedu}</div>,
          };
        },
      },
      {
        title: "Delete",
        key: "operation",
        width: 60,
        align: "center",
        fixed: "right",
        render: (text, record) => (
          <Button
            shape="circle"
            icon="minus"
            onClick={this.onClick.bind(this, record.key)}
          />
        ),
      },
    ];
  }

  // onChange(filters, sorter) {
  //   console.log("params", filters, sorter);
  // }

  onClick = (key) => {
    // const selectedCats = [...this.props.selectedCats];
    // Pass deleted cat back to parent
    this.props.callbackFromParent(key);
  };

  onChangeFormClick = (number, level2, key) => {
    this.props.formCallbackFromParent(number, level2, key);
  };

  // componentDidUpdate() {
  //   console.log("CompareTable: " + (this.props.viewportHeight - 200));
  // }

  handleSave = (row) => {
    const newData = [...this.props.selectedCatsKR];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });

    this.props.editableCallbackFromParent(newData);
  };

  onInputNumberChange(value) {
    if (value > 0 && value < 1000) {
      this.props.levelCallbackFromParent(value);
    }
  }

  render() {
    const dataSourceKR = this.props.selectedCatsKR;
    const innerHeight = this.props.viewportHeight;
    // const innerHeight = 200;

    const components = {
      body: {
        cell: EditableCell,
        row: EditableFormRow,
      },
    };
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <Table
        columns={columns}
        dataSource={dataSourceKR}
        components={components}
        rowClassName={() => "editable-row"}
        scroll={{ x: 2000, y: innerHeight }}
        // onChange={this.onChange.bind(this)}
        size="small"
        loading={false}
        locale={{
          emptyText: (
            <div>
              Create and compare your own custom list of cats.
              <p></p>
              Adjust their forms and levels, and calculate stats for special
              cats, crazed cats, uber rare cats and more. Decide which cats to
              upgrade, and which cats to field in your lineup.
              <p></p>
              Start now by searching for the best battle cats!
            </div>
          ),
        }}
        pagination={{
          position: "bottom",
          hideOnSinglePage: true,
          showQuickJumper: true,
          showSizeChanger: true,
          defaultPageSize: 100,
          pageSizeOptions: ["25", "50", "100", "1500"],
        }}
      />
    );
  }
}

export default CompareTable;



// WEBPACK FOOTER //
// ./src/components-kr/table/CompareTable.js